import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	OIL_FIELD_FEATURE_KEY,
	OilFieldState,
	OilFieldPartialState,
	oilFieldAdapter
} from './oil-field.reducer';

// Lookup the 'OilField' feature state managed by NgRx
export const getOilFieldState = createFeatureSelector<
	OilFieldPartialState,
	OilFieldState
>(OIL_FIELD_FEATURE_KEY);

const { selectAll, selectEntities } = oilFieldAdapter.getSelectors();

export const getOilFieldLoaded = createSelector(
	getOilFieldState,
	(state: OilFieldState) => state.loaded
);

export const getOilFieldError = createSelector(
	getOilFieldState,
	(state: OilFieldState) => state.error
);

export const loadingOilField = createSelector(
	getOilFieldState,
	(state: OilFieldState) => state.loaded
);

export const getAllOilField = createSelector(
	getOilFieldState,
	(state: OilFieldState) => selectAll(state)
);

export const getOilFieldEntities = createSelector(
	getOilFieldState,
	(state: OilFieldState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getOilFieldState,
	(state: OilFieldState) => state.selectedOilFieldId
);

export const getSelected = createSelector(
	getOilFieldEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
